"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateUserPreferredLogin($preferredLogin: String!) {
    updateUserPreferredLogin(preferredLogin: $preferredLogin) {
      _id
      email
      preferredLogin
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateUserPreferredLogIn.mutation.js.map